import React, { Component } from 'react';
import classNames from 'classnames';

export default class NodeInput extends Component {

    constructor(props) {
        super(props);
        this.value = props.initialValue;
    }

    moveCaretAtEnd(e) {
        const tmp = e.target.value;
        e.target.value = '';
        e.target.value = tmp;
    }

    onChange(e) {
        this.value = e.target.value;
        this.props.onChange && this.props.onChange(this.value);
    }

    onComplete() {
        this.props.onComplete(this.value);
    }

    onKeyUp(e) {
        // Enter
        e.keyCode === 13 && this.onComplete();
        // Esc
        e.keyCode === 27 && this.props.onEditingCanceled();
    }

    renderConfirmButton() {
        return (
            <button
                className={classNames("btn", "btn-info", "btn-sm", "mr-1")}
                onClick={this.onComplete.bind(this)}
                role="button"
            >
                OK
            </button>
        );
    }

    renderCancelButton() {
        return (
            <button
                className={classNames("btn", "btn-danger", "btn-sm")}
                onClick={this.props.onEditingCanceled.bind(this)}
                role="button"
            >
                Cancel
            </button>
        );
    }

    render() {
        return (
            <div>
                <input
                    type={'text'}
                    defaultValue={this.value}
                    style={{ border: 0 }}
                    autoFocus
                    onFocus={this.moveCaretAtEnd}
                    onChange={this.onChange.bind(this)}
                    onKeyUp={this.onKeyUp.bind(this)}
                />
                {this.renderConfirmButton()}
                {this.renderCancelButton()}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./web/src/components/categories/NodeInput.jsx